import { Component } from 'react';

import PropTypes from 'prop-types';

import UploadComponent from './UploadComponent';

class FileUploadContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadedFiles: {},
    };
  }

  addItem = (args) => {
    const {
      input: { onChange },
    } = this.props;
    this.setState({
      uploadedFiles: args.target.files,
    });
    onChange(args.target.files);
  };

  removeItem = () => {
    const {
      input: { onChange },
    } = this.props;
    this.setState({
      uploadedFiles: {},
    });
    onChange({});
  };

  render() {
    const { uploadedFiles } = this.state;
    const props = {
      ...this.props,
      selectedFiles: Object.values(uploadedFiles),
      addItem: this.addItem,
      removeItem: this.removeItem,
    };
    return <UploadComponent {...props} />;
  }
}
FileUploadContainer.defaultProps = {
  onChange: () => {},
};
FileUploadContainer.propTypes = {
  onChange: PropTypes.func,
  input: PropTypes.instanceOf(Object).isRequired,
};

export default FileUploadContainer;
